import { StateCreator } from "zustand";
import { AccountSetting, SettingsState, SettingsThresholds } from "./types";

export const createSettingsSlice: StateCreator<
  { settings: SettingsState },
  [],
  [],
  { settings: SettingsState }
> = (set) => ({
  settings: {
    thresholds: {},
    setThresholds: (thresholds: SettingsThresholds[]) =>
      set((state) => ({
        settings: {
          ...state.settings,
          thresholds: thresholds.reduce(
            (acc, threshold) => {
              acc[threshold.id] = threshold;
              return acc;
            },
            {} as Record<string, SettingsThresholds>
          )
        }
      })),
    accountSettings: {},
    setAccountSettings: (settings: AccountSetting[]) =>
      set((state) => ({
        settings: {
          ...state.settings,
          accountSettings: settings.reduce(
            (acc, setting) => {
              acc[setting.key] = setting;
              return acc;
            },
            {} as Record<string, AccountSetting>
          )
        }
      })),
    setAccountSetting: (setting: AccountSetting) =>
      set((state) => ({
        settings: {
          ...state.settings,
          accountSettings: {
            ...state.settings.accountSettings,
            [setting.key]: setting
          }
        }
      }))
  }
});
